import { combineReducers } from 'redux';
import { handleAction } from 'redux-actions';

import heroBlock from 'app/features/landing/heroBlock/reducer';
import devices from 'app/features/landing/devices/reducer';
import seriesCollection from 'app/features/landing/seriesCollection/reducer';
import productComparison from 'app/features/landing/productComparison/reducer';
import viewPlansCta from 'app/features/landing/viewPlansCta/reducer';
import { FETCH_DELTA_CONFIG_SUCCESS } from 'app/features/deltaConfig/actionTypes';
import { LANDING_PAGE } from 'app/features/deltaConfig/constants';
import { pathOrFromPayload } from 'app/reducers/helpers';

const isNewExperience = handleAction(
  FETCH_DELTA_CONFIG_SUCCESS,
  pathOrFromPayload(false, [LANDING_PAGE, 'isNewExperience']),
  false,
);

const landing = combineReducers({
  isNewExperience,
  heroBlock,
  devices,
  seriesCollection,
  productComparison,
  viewPlansCta,
});

export { isNewExperience };

export default landing;
